import { render, staticRenderFns } from "./CollectPaymentView.vue?vue&type=template&id=af310bae&scoped=true"
import script from "./CollectPaymentView.vue?vue&type=script&lang=js"
export * from "./CollectPaymentView.vue?vue&type=script&lang=js"
import style0 from "./CollectPaymentView.vue?vue&type=style&index=0&id=af310bae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af310bae",
  null
  
)

export default component.exports